import { render } from "./CardWrapper.vue?vue&type=template&id=0e9faec0&scoped=true"
import script from "./CardWrapper.vue?vue&type=script&lang=js"
export * from "./CardWrapper.vue?vue&type=script&lang=js"

import "./CardWrapper.vue?vue&type=style&index=0&id=0e9faec0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e9faec0"]])

export default __exports__